import _ from 'lodash';
import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import {withStyles} from "@material-ui/core/styles";
import TicketCategoryContainer from '../../containers/Ticket/TicketCategory';
import FormSelect from "../form/FormSelect";

const styles = () => {
	return {
		fetching : {
			fontStyle : 'italic',
			padding : '10px 0px',
			color : '#777',
		},
	};
};

class ParentTicketCategoryPicker extends PureComponent {
	componentDidMount  () {
		if (_.isEmpty(this.props.ticketCategories)) {
			this.props.searchTicketCategories();
		}
	}

	//- Called from the select
	render () {
		const {ticketCategories, classes} = this.props;

		if (_.isEmpty(ticketCategories)) {
			return (<div className={classes.fetching}>Fetching departments...</div>);
		}

		const options = _.sortBy(ticketCategories, 'displayName').reduce((result, ticketCategory) => {
			const { ticketCategoryId, displayName, parentTicketCategoryIds } = ticketCategory;

			if (!_.isEmpty(parentTicketCategoryIds)) {
				return result;
			}

			result.push({
				value : ticketCategoryId,
				display : displayName,
			});
			return result;
		}, []);

		return (
			<FormSelect
				{...this.props}
				options={options}
			/>
		);
	}
}

ParentTicketCategoryPicker.propTypes = {
	label : PropTypes.string,
	value :	PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
	path: PropTypes.string.isRequired,
	onChange : PropTypes.func.isRequired,
	error : PropTypes.string,

	classes : PropTypes.object,
	helpText : PropTypes.string,

	searchTicketCategories: PropTypes.func,
	ticketCategories : PropTypes.array,
};

ParentTicketCategoryPicker.defaultProps =  {
	label : 'Ticket Category',
};

export default _.flow([
	withStyles(styles),
	TicketCategoryContainer,
])(ParentTicketCategoryPicker);